import { render, staticRenderFns } from "./SmTextConvertedToBoldAndStrikethrough.vue?vue&type=template&id=fbb265d0&scoped=true&"
import script from "./SmTextConvertedToBoldAndStrikethrough.vue?vue&type=script&lang=ts&"
export * from "./SmTextConvertedToBoldAndStrikethrough.vue?vue&type=script&lang=ts&"
import style0 from "./SmTextConvertedToBoldAndStrikethrough.vue?vue&type=style&index=0&id=fbb265d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb265d0",
  null
  
)

export default component.exports